import { PlanFeatureResponse } from '../../Interfaces/api/backoffice/feature.interface';

export class PlanFeature {
  id = '';
  key = '';
  category: string | null = null;
  sort_order = 0;
  is_active = false;
  granted = false;

  constructor(data: Partial<PlanFeatureResponse> = {}) {
    Object.assign(this, data);
  }

  get categoryLabel(): string {
    return this.category ?? '';
  }
}
